import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from '../profile/constants';

const lazy = {
    EditProfileDetailsPage: lazyLoad(async () => {
        const { EditProfileDetails } = await import('./EditProfileDetails');

        return { default: EditProfileDetails };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.recruiter-profile.details.title',
        page: lazy.EditProfileDetailsPage,
        path: route.patterns.individualUser.profileDetails.edit,
    },
];
